import CustomValueLabel from './CustomValueLabel';

export default CustomValueLabel;
